import { render, staticRenderFns } from "./DanInput.vue?vue&type=template&id=3530ef1c&scoped=true&"
import script from "./DanInput.vue?vue&type=script&lang=js&"
export * from "./DanInput.vue?vue&type=script&lang=js&"
import style0 from "./DanInput.vue?vue&type=style&index=0&id=3530ef1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530ef1c",
  null
  
)

export default component.exports